import React from "react";
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import compose from 'recompose/compose';

import PropTypes from "prop-types";

import axios from 'axios'
import { db } from "firebase/fbConfig.js"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";

class Form extends React.Component {
  state = {
    comment: '',
    queryString: "",
    actionAssigned: false,
    assignedError: false,
    defaultLoaded: false,
    assigningAction: "",
    cardAnimaton: "cardHidden",
    messageSent: false,
    messageError: false
  }
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
    shippingMode: '',
    pickUpServices: '',
    dropOffServices: '',
    services: '',
    items: [],
      userSet: false
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
    //console.log(this.state)
  }

    handlePickUpDateChange = (pickUpDate) => {
    //console.log(pickUpDate._d)
    if (pickUpDate) {
      this.setState(() => ({ pickUpDate: pickUpDate._d }))
    }
  }

   handleDropOffDateChange = (dropOffDate) => {
    //console.log(dropOffDate)
    if (dropOffDate) {
      this.setState(() => ({ dropOffDate: dropOffDate._d }))
    }
  }

  // only make future selectable  
  valid = (current) => {
    return current.isAfter(Datetime.moment().subtract(1, 'day'));
  };

  handleSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleTogglePickupServices(value) {
    const { pickUpServices } = this.state;
    const currentIndex = pickUpServices.indexOf(value);
    const newPickUpServices = [...pickUpServices];

    if (currentIndex === -1) {
      newPickUpServices.push(value);
    } else {
      newPickUpServices.splice(currentIndex, 1);
    }

    this.setState({
      pickUpServices: newPickUpServices
    });
  }

  handleToggleDropOffServices(value) {
    const { dropOffServices } = this.state;
    const currentIndex = dropOffServices.indexOf(value);
    const newDropOffServices = [...dropOffServices];

    if (currentIndex === -1) {
      newDropOffServices.push(value);
    } else {
      newDropOffServices.splice(currentIndex, 1);
    }

    this.setState({
      dropOffServices: newDropOffServices
    });
  }

  handleToggleServices(value) {
    const { services } = this.state;
    const currentIndex = services.indexOf(value);
    const newServices = [...services];

    if (currentIndex === -1) {
      newServices.push(value);
    } else {
      newServices.splice(currentIndex, 1);
    }

    this.setState({
      services: newServices
    });
  }


  handleSubmit = (e) => {
    e.preventDefault();
      // update firestore document with PENDING and comment
      
      db.collection("orders").add({
        ...this.state,
        uid: this.state.uid,
        status: "pending",
        page: window.location.pathname,
        updatedAt: new Date()
      }).then((docRef) => {
        db.collection("TEST-users").doc(this.state.uid).collection("orders").doc(docRef.id).set({
          ...this.state,
          uid: this.state.uid,
          status: "pending",
          page: window.location.pathname,
          updatedAt: new Date()
        }, {merge: true}).then(() => {
          console.log(``)
          this.setState({
            messageSent: true
          })       
        }).catch((err) => {
          console.log(`${err}`)
        })
      }).catch((err) => {
        console.log(`${err}`)
      })
  }

  resetRequest = () => {
    window.location.reload();
  }

   setUser = (user) => {
      this.setState({
        uid: user,
        userSet: true
      })
      console.log(this.state)
    }

  render() {
    const { classes, modalClose, authUser } = this.props;

    const shippingModes = ['', 'LTL', 'TL']
    const locationTypes = ['','Business', 'Construction Site', 'Convention Center or Tradeshow', 'Freight Carrier Terminal', 'Home Based Business', 'Mlitary Base', 'Mini-Storage / Self Storage Facility', 'Religious Institution', 'Residential / Home']
    const packagingTypes = ['','Pallets: Standard (40" x 48")', 'Pallets (48" x 48")', 'Pallets (60" x 48")', 'Pallets (enter dimensions)', 'Boxed', 'Crated', 'Drums or Barrels']
    const freightClass = ['','I dont know', '50', '55', '60', '65', '70', '77.5', '85', '92.5', '100', '110', '125', '150', '175', '200', '250', '300', '400', '500']
   
    if (authUser && !this.state.userSet) { this.setUser(authUser.uid) }
    //console.log(authUser)
    // reset modal when closed
    if (this.state.messageSent) { this.resetRequest() }

    return (
      <div>
        {this.state.messageSent ? (
          <GridContainer justify="center">
            <GridItem xs={11}>
              <h4 className={classes.textPrimary}>Order Submitted!</h4>

            </GridItem>
          </GridContainer>
        ) : (
            <div className={classes.formContainer}>
              <form onSubmit={this.handleSubmit}
              >
                <GridContainer justify="center">
                  <GridItem xs={11}>
                    {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error: {this.state.messageError}</h5> : null}
                <GridItem xs={6}>
                  </GridItem>
                  <FormControl
                  fullWidth
                  className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="shippingmode"
                    className={classes.selectLabel}>
                    SHIPPING MODE:
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={this.state.shippingMode}
                    onChange={this.handleSelectChange}
                    inputProps={{
                      id: 'shippingMode',
                      name: 'shippingMode'
                    }}
                  >
                    {
                      shippingModes.map((item) => (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem
                          }}
                          value={item}
                          key={item}
                        >{item}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>

                <br/>
                <br/>
                <h3 className={classes.bodyText}>START LOCATION</h3>

                    <CustomInput
                      labelText="City or ZIP"
                      id="origin"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        type: "text",
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <FormControl
                    fullWidth
                    className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="originType"
                      className={classes.selectLabel}>
                      LOCATION TYPE:
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      value={this.state.originType}
                      onChange={this.handleSelectChange}
                      inputProps={{
                        id: 'originType',
                        name: 'originType'
                      }}
                    >
                      {
                        locationTypes.map((item) => (
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem
                            }}
                            value={item}
                            key={item}
                          >{item}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                  <Datetime
                  selected={this.state.pickUpDate}
                  onChange={this.handlePickUpDateChange}
                  timeFormat={true}
                  isValidDate={this.valid}
                  renderInput={(dateInputProps, open, close) => (
                    <CustomInput
                      inputProps={{ ...dateInputProps, id: 'pickUpDate', name: 'pickUpDate', required: true, }}
                      onBlur={close}
                      onFocus={open}
                      labelText="Pickup Date"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  )}
                />

                  <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                  <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={() => this.handleTogglePickupServices('Lift Gate')}
                        checked={this.state.pickUpServices.indexOf('Lift Gate') !== -1 ? true : false}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        color="primary"
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                      />
                    }
                    classes={{ label: classes.bodyText }}
                    label='Lift Gate at Pickup Point'
                  />
                </div>
                <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                <FormControlLabel
                  control={
                    <Checkbox
                      tabIndex={-1}
                      onClick={() => this.handleTogglePickupServices('Limited Access')}
                      checked={this.state.pickUpServices.indexOf('Limited Access') !== -1 ? true : false}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      color="primary"
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                    />
                  }
                  classes={{ label: classes.bodyText }}
                  label='Limited Access Pick Up'
                />
              </div>

  

                    <CustomInput
                      labelText="Notes"
                      id="description"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        id: "pickUpNotes",
                        name: "pickUpNotes",
                        type: "text",
                        multiline: true,
                        rows: 5,
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <br />
                    <h3 className={classes.bodyText}>END LOCATION</h3>

                    <CustomInput
                      labelText="City or ZIP"
                      id="destination"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        type: "text",
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <FormControl
                    fullWidth
                    className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="destinationType"
                      className={classes.selectLabel}>
                      LOCATION TYPE:
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      value={this.state.destinationType}
                      onChange={this.handleSelectChange}
                      inputProps={{
                        id: 'destinationType',
                        name: 'destinationType'
                      }}
                    >
                      {
                        locationTypes.map((item) => (
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem
                            }}
                            value={item}
                            key={item}
                          >{item}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                  <Datetime
                  selected={this.state.dropOffDate}
                  onChange={this.handleDropOffDateChange}
                  timeFormat={true}
                  isValidDate={this.valid}
                  renderInput={(dateInputProps, open, close) => (
                    <CustomInput
                      inputProps={{ ...dateInputProps, id: 'dropOffDate', name: 'dropOffDate', required: true, }}
                      onBlur={close}
                      onFocus={open}
                      labelText="Drop Off Date"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  )}
                />
                <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                <FormControlLabel
                  control={
                    <Checkbox
                      tabIndex={-1}
                      onClick={() => this.handleToggleDropOffServices('Lift Gate')}
                      checked={this.state.dropOffServices.indexOf('Lift Gate') !== -1 ? true : false}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      color="primary"
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                    />
                  }
                  classes={{ label: classes.bodyText }}
                  label='Lift Gate at Pickup Point'
                />
              </div>
              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
              <FormControlLabel
                control={
                  <Checkbox
                    tabIndex={-1}
                    onClick={() => this.handleToggleDropOffServices('Limited Access')}
                    checked={this.state.dropOffServices.indexOf('Limited Access') !== -1 ? true : false}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    color="primary"
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot
                    }}
                  />
                }
                classes={{ label: classes.bodyText }}
                label='Limited Access Pick Up'
              />
            </div>

                    <CustomInput
                      labelText="Notes"
                      id="dropOffNotes"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        multiline: true,
                        rows: 5,
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <br />

                    <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          tabIndex={-1}
                          onClick={() => this.handleToggleServices('Hazmat')}
                          checked={this.state.services.indexOf('Hazmat') !== -1 ? true : false}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          color="primary"
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                        />
                      }
                      classes={{ label: classes.bodyText }}
                      label='Hazmat'
                    />
                  </div>
                  <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={() => this.handleToggleServices('Over Length')}
                        checked={this.state.services.indexOf('Over Length') !== -1 ? true : false}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        color="primary"
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                      />
                    }
                    classes={{ label: classes.bodyText }}
                    label='Over Length'
                  />
                </div>


                <h3 className={classes.bodyText}>ITEMS TO BE SHIPPED</h3>
                <FormControl
                fullWidth
                className={classes.selectFormControl}>
                <InputLabel
                  htmlFor="packaging"
                  className={classes.selectLabel}>
                  PACKAGING:
                </InputLabel>
                <Select
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  classes={{
                    select: classes.select
                  }}
                  value={this.state.packaging}
                  onChange={this.handleSelectChange}
                  inputProps={{
                    id: 'packaging',
                    name: 'packaging'
                  }}
                >
                  {
                    packagingTypes.map((item) => (
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem
                        }}
                        value={item}
                        key={item}
                      >{item}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>


                <CustomInput
                      labelText="Qty"
                      id="quantity"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        type: "number",
                        min: "0",
                        step: "1",
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <CustomInput
                    labelText="Total Weight"
                    id="weight"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      required: true,
                      type: "number",
                      min: "0",
                      step: "1",
                      onChange: (event) => this.handleChange(event)
                    }}
                  />
                  <CustomInput
                  labelText="Height"
                  id="height"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    required: true,
                    type: "number",
                    min: "0",
                    step: "1",
                    onChange: (event) => this.handleChange(event)
                  }}
                />

                <CustomInput
                labelText="Width"
                id="width"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  required: true,
                  type: "number",
                  min: "0",
                  step: "1",
                  onChange: (event) => this.handleChange(event)
                }}
              />

              <CustomInput
              labelText="Depth"
              id="depth"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                required: true,
                type: "number",
                min: "0",
                step: "1",
                onChange: (event) => this.handleChange(event)
              }}
            />

            <FormControl
            fullWidth
            className={classes.selectFormControl}>
            <InputLabel
              htmlFor="class"
              className={classes.selectLabel}>
              FREIGHT CLASS:
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={this.state.class}
              onChange={this.handleSelectChange}
              inputProps={{
                id: 'class',
                name: 'class'
              }}
            >
              {
                freightClass.map((item) => (
                  <MenuItem
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={item}
                    key={item}
                  >{item}</MenuItem>
                ))
              }
            </Select>
          </FormControl>

                  </GridItem>
                </GridContainer>
                {this.state.assigningAction ? (
                  <div>
                    <p className={classes.bodyText}>{this.state.assigningAction}</p>                   
                  </div>
                ) : (
                    <Button
                      type="submit"
                      color="primary"
                      style={{
                        marginLeft: "10px",
                        marginBottom: "10px"
                      }}
                    >
                      SUBMIT
              </Button>
                  )}
              </form>
            </div>

          )}
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    //console.log(state)
    return {
      AuthBool: !!state.auth.user,
      authUser: state.auth.user,
      user: state.profile.user,
    }
  }
  
export default compose(
    connect(mapStateToProps),
    withStyles(styles)
  )(Form);


// WEBPACK FOOTER //
// ./src/components/Forms/FeedForms.jsx